module.exports = __webpack_public_path__ + "static/media/wave.aab6b1a0.svg";